import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { Rect } from "../../MyHelpers";
import { SlotGameInitData } from "../../SlotGameInitData";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam } from "../ExpandingWildBulk";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1 } from "../SlotGameType1";
// namespace SlotGames
// namespace SlotGames
// {

	export class AncientSea3DClassic extends SlotGameType1 
	{
		protected override helpFactory:IHelpFactory = new AncientSea3DClassicHelpFactory();

		protected override panelColor: ButtonColors ={
			backgroundButtonColor: "linear-gradient(rgb(1, 6, 38),rgb(1, 17, 34), rgb(2, 40, 115),rgb(1, 17, 34),rgb(1, 6, 38)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
		}
		

		//SEND COLOR FOR RSA 
        protected override color: RewardColor = 
        {
            color: "#F1F0C9",
		    coloroutherStroke: "black",
            colorinnerStroke: "#9F8DF4",
        }

		//LED COLOR
		protected override ColorLed:string="173,83,255\n";
		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "AncientSea3DClassic");

			
			this.spinnableReelsParams.topBorderWidth = 10;
			this.spinnableReelsParams.bottomBorderWidth = 10;
		}
	}


	class AncientSea3DClassicFreegamePickElement extends FreegamePickElement
	{
		public override AwardElemePrepare()
		{
			super.AwardElemePrepare();
			this.awardElem.style.left = "-4px";
			this.awardElem.style.top = "2px";
			this.awardElem.style.fontSize ="150px";
			
		}

		protected override PreparePickedElement(): void
		{
			this.awardElem.style.color = "white";
			this.awardElem.style.fontSize = "150px";
			this.awardElem.style.fontWeight="bold";
		}

		protected override PrepareRemainingElement(): void
		{
			this.awardElem.style.removeProperty("color");
			this.awardElem.style.removeProperty("fontSize");
		}
	}

	class AncientSea3DClassicHelpFactory implements IHelpFactory
	{
		public CreateNewHelp(params: HelpParameters):Help
		{
			return new AncientSea3DClassicHelp(params);
		}
	}

	class AncientSea3DClassicHelp extends Help
	{
		protected override BackgroundPanel():HelpPanelColor
		{
			let color:HelpPanelColor = {
				backgroundPanelColor: "linear-gradient(rgb(1, 6, 38),rgb(1, 17, 34), rgb(2, 40, 115),rgb(1, 17, 34),rgb(1, 6, 38)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			};

			return color;
		}
	}


	// class AncientSea3DClassicFreegameBonusFactory extends FreegameBonusFactory
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
	// 	{
	// 		return new AncientSea3DClassicFreegame(gameName, params);
	// 	}
		
		
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new AncientSea3DClassicFreegamePickElement(params);
	// 	}
		
	// }
// }
